<template>
    <div class="cca-mgmt-page p-3">
        
        <!-- ສ່ວນການຄົ້ນຫາ ແລະ ຈັດການຂໍ້ມູນ -->
        <b-card class="shadow-sm border-0 mb-4 bg-white rounded-lg">
            <template #header>
                <div class="d-flex align-items-center justify-content-between py-1">
                    <h5 class="mb-0 text-primary font-weight-bold">
                        <b-icon icon="clipboard-check-fill" class="mr-2"></b-icon>
                        ຈັດການຂໍ້ມູນແບບສອບຖາມ (CCA)
                    </h5>
                    <b-button variant="success" @click="addnew" class="px-3 shadow-sm font-weight-bold">
                        <b-icon icon="plus-circle" class="mr-1"></b-icon> ເພີ່ມແບບສອບຖາມໃໝ່
                    </b-button>
                </div>
            </template>

            <b-row align-v="end">
                <b-col cols="12" md="3" class="mb-2 mb-md-0">
                    <label class="small text-muted font-weight-bold mb-1">ຄົ້ນຫາຕາມ:</label>
                    <b-form-select v-model="field" :options="searchOptions" class="rounded-pill border-primary-light">
                        <template #first>
                            <b-form-select-option value="" disabled>-- ເລືອກຫົວຂໍ້ --</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col cols="12" md="3" class="mb-2 mb-md-0">
                    <label class="small text-muted font-weight-bold mb-1">ຄຳຄົ້ນຫາ:</label>
                    <b-form-input type="text" v-model="find" placeholder="ປ້ອນຂໍ້ມູນຄົ້ນຫາ..." class="rounded-pill"></b-form-input>
                </b-col>
                <b-col cols="12" md="3" class="mb-2 mb-md-0">
                    <label class="small text-muted font-weight-bold mb-1">ວັນທີເກັບຂໍ້ມູນ:</label>
                    <b-form-datepicker v-model="fdate" placeholder="ເລືອກວັນທີ" locale="lo" class="rounded-pill"></b-form-datepicker>
                </b-col>
                <b-col cols="12" md="3">
                    <b-button variant="primary" @click="onSearch" block class="rounded-pill shadow-sm font-weight-bold">
                        <b-icon icon="search" class="mr-1"></b-icon> ຄົ້ນຫາຂໍ້ມູນ
                    </b-button>
                </b-col>
            </b-row>
        </b-card>

        <!-- ຕາຕະລາງສະແດງຂໍ້ມູນ -->
        <b-card no-body class="shadow-sm border-0 overflow-hidden rounded-lg">
            <b-table 
                head-variant="light" 
                hover 
                striped
                :fields="tableFields" 
                :items="items" 
                class="cca-table mb-0" 
                responsive="sm"
            >
                <template #cell(index)="data">
                    <span class="text-muted small font-weight-bold">{{ data.index + 1 }}</span>
                </template>

                <template #cell(info)="data">
                    <div class="py-1">
                        <div class="font-weight-bold text-dark">{{ data.item.s1.schoolName }}</div>
                        <div class="small text-muted">
                            <b-icon icon="geo-alt-fill" class="mr-1"></b-icon>
                            {{ data.item.s1.villageName }}, {{ data.item.s1.district }}, {{ data.item.s1.province }}
                        </div>
                    </div>
                </template>

                <template #cell(collectionDate)="data">
                    <span class="small">{{ data.item.s1.collectionDate | formatdate }}</span>
                </template>

                <template #cell(collector)="data">
                    <div class="small font-weight-bold">{{ data.item.s1.collectorName }}</div>
                    <div class="small text-muted">{{ data.item.s1.collectorPhone }}</div>
                </template>

                <template #cell(modify)="data">
                    <div class="small font-weight-bold">{{ data.item.update_by }}</div>
                    <div class="small text-muted">{{ data.item.update_at | formatdate }}</div>
                </template>

                <template #cell(action)="data">
                    <div class="d-flex justify-content-center align-items-center">
                        <b-button variant="link" size="sm" class="text-info mr-2 p-0 action-btn" @click="edit(data.item._id)" v-b-tooltip.hover title="ແກ້ໄຂ">
                            <b-icon icon="pencil-square" font-scale="1.2"></b-icon>
                        </b-button>
                        <b-button variant="link" size="sm" class="text-danger p-0 action-btn" @click="del(data.item._id)" v-b-tooltip.hover title="ລຶບ">
                            <b-icon icon="trash-fill" font-scale="1.2"></b-icon>
                        </b-button>
                    </div>
                </template>
            </b-table>
        </b-card>

        <!-- Loading ຂໍ້ມູນແບບ Infinite -->
        <div class="mt-4 pb-5 text-center">
            <infinite-loading @infinite="infiniteHandler" spinner="spiral">
                <div slot="spinner" class="py-3">
                    <b-spinner variant="primary" small></b-spinner>
                    <span class="ml-2 text-muted small">ກຳລັງໂຫຼດຂໍ້ມູນ...</span>
                </div>
                <div slot="no-more" class="py-3 text-muted small italic">-- ສິ້ນສຸດຂໍ້ມູນ --</div>
                <div slot="no-results" class="py-3 text-muted small italic">-- ບໍ່ພົບຂໍ້ມູນ --</div>
            </infinite-loading>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import InfiniteLoading from "vue-infinite-loading";
import moment from 'moment';

export default {
    name: 'CCAManagement',
    components: { InfiniteLoading },
    data() {
        return {
            page: 0,
            field: 's1.schoolName',
            find: '',
            fdate: '',
            items: [],
            user: {},
            searchOptions: [
                { value: 's1.schoolName', text: 'ຊື່ໂຮງຮຽນ' },
                { value: 's1.villageName', text: 'ຊື່ບ້ານ' },
                { value: 's1.collectorName', text: 'ຊື່ຜູ້ເກັບຂໍ້ມູນ' },
                { value: 's1.schoolCode', text: 'ລະຫັດໂຮງຮຽນ' }
            ],
            tableFields: [
                { key: 'index', label: 'ລຳດັບ', thClass: 'text-center', tdClass: 'text-center' },
                { key: 'info', label: 'ຂໍ້ມູນໂຮງຮຽນ / ທີ່ຕັ້ງ' },
                { key: 'collector', label: 'ຜູ້ເກັບຂໍ້ມູນ' },
                { key: 'collectionDate', label: 'ວັນທີເກັບຂໍ້ມູນ', thClass: 'text-center', tdClass: 'text-center' },
                { key: 'modify', label: 'ຜູ້ແກ້ໄຂ' },
                { key: 'action', label: 'ຈັດການ', thClass: 'text-center', tdClass: 'text-center' }
            ]
        }
    },
    filters: {
        formatdate(value) {
            if (value) return moment(String(value)).format('DD/MM/YYYY');
            return '—';
        }
    },
    created() {
        const login = localStorage.getItem("Login");
        if (login) this.user = JSON.parse(login);
    },
    methods: {
        async fetchData(offset = 0) {
            const baseUrl = this.$store.getters.getBaseUrl;
            const params = `?offset=${offset}&fld=${this.field}&find=${this.find}&fdate=${this.fdate}&table=CCA_Assessments`;
            // ໝາຍເຫດ: 999 ແມ່ນ placeholder ສໍາລັບ menu_id ຖ້າຈໍາເປັນຕ້ອງໃຊ້ຕາມ pattern ເດີມ
            return axios.get(`${baseUrl}/fech_CCA${params}`, {
                headers: { 'Authorization': 'Bearer ' + this.user.login_hash }
            });
        },
        infiniteHandler($state) {
            this.fetchData(this.page).then(response => {
                if (response.data.items && response.data.items.length > 0) {
                    this.page++;
                    this.items = this.items.concat(response.data.items);
                    $state.loaded();
                } else {
                    $state.complete();
                }
            }).catch(() => $state.complete());
        },
        onSearch() {
            this.page = 0;
            this.items = [];
            this.fetchData(0).then(response => {
                this.items = response.data.items || [];
                this.page = 1;
            });
        },
        addnew() {
            // ສົ່ງໄປໜ້າຟອມແບບສອບຖາມ
            this.$router.push('/cca-form');
        },
        edit(id) {
            // ສົ່ງ ID ໄປຫາໜ້າຟອມເພື່ອດຶງຂໍ້ມູນມາແກ້ໄຂ
            this.$router.push({ path: '/cca-form', query: { id: id } });
        },
        del(id) {
            this.$bvModal.msgBoxConfirm('ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການລົບຂໍ້ມູນນີ້?', {
                title: 'ຢືນຢັນການລົບ',
                okVariant: 'danger',
                okTitle: 'ລົບອອກ',
                cancelTitle: 'ຍົກເລີກ',
                centered: true,
                buttonSize: 'sm'
            }).then(value => {
                if (value) {
                    const params = { table: 'CCA_Assessments', code: id, fields: { status: 'D', del_by: this.user.username, del_date: new Date() } };
                    axios.post(this.$store.getters.getBaseUrl + '/del', params, {
                        headers: { 'Authorization': 'Bearer ' + this.user.login_hash }
                    }).then(res => {
                        if (res.data.code == 1) {
                            this.$bvToast.toast('ລົບຂໍ້ມູນສຳເລັດແລ້ວ', { title: 'ແຈ້ງເຕືອນ', variant: 'success', appendToast: true });
                            this.onSearch();
                        }
                    });
                }
            });
        }
    }
};
</script>

<style scoped>
.cca-mgmt-page {
    background-color: #f4f7f6;
    min-height: 100vh;
    font-family: 'Noto Sans Lao', sans-serif;
}
.rounded-lg { border-radius: 12px !important; }
.cca-table { font-size: 0.9rem; }
.cca-table ::v-deep th, .cca-table ::v-deep td {
    white-space: nowrap !important;
    vertical-align: middle !important;
    padding: 12px 15px !important;
}
.action-btn { transition: transform 0.2s ease; }
.action-btn:hover { transform: scale(1.2); }
</style>